import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [TranslateModule],
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  public readonly titleTranslationKey: string;

  private readonly router = inject(Router);

  constructor() {
    const state = (this.router.getCurrentNavigation()?.extras.state ?? (history.state as unknown)) as
      | Record<string, unknown>
      | undefined;

    this.titleTranslationKey = (state?.['titleKey'] as string) ?? 'pages.notFound.title';
  }
}
